export const HOME = '/';
export const HOME_HU = '/hu';
// export const SIGNUP = '/sign-up';
// export const SIGNIN = '/sign-in';
// export const PASSWORDFORGET = '/password-forget';
// export const ACCOUNT = '/account';
// export const ADMIN = '/admin';